import React from 'react';
import { useRouter } from 'next/router';
import { Stack, ButtonVariant, Typography } from '@krakentech/coral';
import {
  IconBars,
  IconArrowRotate,
  IconCircleQuestionFilled,
  IconArrowRightFromBracket,
  IconCross,
} from '@krakentech/icons';
import styled from 'styled-components';

import IconDropdown from '@/components/IconDropdown';
import PIITypography from '@/components/PII/PIITypography';
import { AccountNumberContextProvider } from '@/context/AccountNumberContext/withFetch/AccountNumberContext';
import { sessionAccountNumberKey } from '@/context/AccountNumberContext/withFetch/sessionKey';
import { useFullNameAndSupplyAddress } from '@/hooks/accounts/useFullNameAndSupplyAddress';
import { useLogout } from '@/hooks/utils/useLogout';
import { isStw, isLeep } from '@/utils/environment';
import { INTERNAL_PATHS } from '@/utils/urls';

const PortfolioControls = () => {
  const router = useRouter();
  const { logout } = useLogout();

  const { data: accountData } = useFullNameAndSupplyAddress();

  const currentAddress = accountData?.account?.properties?.[0]?.address ?? '';

  const contactUsHref = isStw()
    ? 'https://www.stwater.co.uk/search/'
    : process.env.NEXT_PUBLIC_HELP_LINK;

  const dropdownItems = [
    {
      label: 'Switch Account',
      onClick: () => {
        router.push(INTERNAL_PATHS.PORTFOLIO_OVERVIEW.path);
        sessionStorage.removeItem(sessionAccountNumberKey);
      },
      icon: <IconArrowRotate size={16} />,
    },
    {
      label: 'Help',
      onClick: () => {
        window.open(contactUsHref, '_blank');
      },
      icon: <IconCircleQuestionFilled size={16} />,
    },
    {
      label: 'Log Out',
      onClick: logout,
      icon: <IconArrowRightFromBracket size={16} />,
    },
  ];

  const iconDropdownButtonVariant: ButtonVariant =
    isStw() || isLeep() ? 'ghost' : 'contained';

  return (
    <Stack alignItems="center">
      {currentAddress ? (
        <StyledAddress>
          <PIITypography color="light" variant="h3">
            {currentAddress}
          </PIITypography>
        </StyledAddress>
      ) : (
        <Typography color="light" variant="h3">
          Vacated property
        </Typography>
      )}
      <IconDropdown
        items={dropdownItems}
        closedIcon={<IconBars size={18} />}
        openIcon={<IconCross size={18} />}
        variant={iconDropdownButtonVariant}
      />
    </Stack>
  );
};

const PortfolioControlsWithContext = () => {
  return (
    <AccountNumberContextProvider>
      <PortfolioControls />
    </AccountNumberContextProvider>
  );
};

export default PortfolioControlsWithContext;

const StyledAddress = styled.div`
  margin-right: 16px;
`;
